/**
 * Shared bits for the IAM directory hooks (users / groups / roles). The IAM
 * control plane hangs off the same service-scoped storage base; every entity
 * name is opaque and may carry reserved URL characters, so callers always send
 * it path-encoded (see `iamPath`).
 */
import { storageBase } from './_shared';

/** A managed policy attached to a user, group or role. */
export interface AttachedPolicy {
  policy_name: string;
  policy_arn: string;
}

/** Base path for the IAM control plane on one provisioned storage service. */
export function iamBase(serviceId: string): string {
  return `${storageBase(serviceId)}/iam`;
}

/** Build an IAM sub-path with the entity name safely encoded into the URL. */
export function iamPath(serviceId: string, resource: string, name: string, suffix = ''): string {
  return `${iamBase(serviceId)}/${resource}/${encodeURIComponent(name)}${suffix}`;
}
